// extracted by mini-css-extract-plugin
export var callCard = "_pf-0";
export var callMessageButton = "_pf-1";
export var helpIcon = "_pf-3";
export var helpIconContainer = "_pf-4";
export var verticalDivider = "_pf-2";